import { extendTheme, Tag } from '@chakra-ui/react'
import { ButtonProps } from './components/button'
import { CardProps } from './components/card'
import { CheckboxProps } from './components/checkbox'
import { InputProps } from './components/input'
import { Select } from './components/select'
import { Textarea } from './components/textarea'
import { RadioProps } from './components/radio'
import { PopoverProps } from './components/popover'
import { colors, fonts } from './foundations'

const theme = extendTheme({
  fonts,
  textStyles: {
    'd-xxs': {
      fontSize: '24px',
      fontWeight: '600',
      lineHeight: '32px',
    },
    'd-xs': {
      fontSize: '32px',
      fontWeight: '600',
    },
    'd-s': {
      fontSize: '36px',
      fontWeight: '600',
    },
    'd-md': {
      fontSize: '40px',
      fontWeight: '600',
    },
    'd-lg': {
      fontSize: '44px',
      fontWeight: '600',
    },
    'l-xxs': {
      fontSize: '10px',
      fontWeight: '500',
    },
    'l-xs': {
      fontSize: '12px',
      fontWeight: '500',
    },
    'l-s': {
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '20px',
    },
    'l-md': {
      fontSize: '16px',
      fontWeight: '500',
    },
    'l-lg': {
      fontSize: '18px',
      fontWeight: '500',
    },
    'h-xxs': {
      fontSize: '12px',
      fontWeight: '600',
      lineHeight: '16px',
    },
    'h-xs': {
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '20px',
    },
    'h-s': {
      fontSize: '16px',
      fontWeight: '600',
    },
    'h-md': {
      fontSize: '18px',
      fontWeight: '600',
    },
    'h-lg': {
      fontSize: '20px',
      fontWeight: '600',
    },
    'h-ov': {
      fontSize: '12px',
      fontWeight: '600',
    },
    'b-xxs': {
      fontSize: '10px',
      fontWeight: '400',
      lineHeight: '16px',
    },
    'b-xs': {
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '16px',
    },
    'b-s': {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '16px',
    },
    'b-md': {
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '16px',
    },
    'b-lg': {
      fontSize: '18px',
      fontWeight: '400',
      lineHeight: '16px',
    },
  },
  colors,
  styles: {
    global: {
      body: {
        overflowX: 'hidden',
      },
      '*': {
        scrollbarWidth: 'thin',
        scrollbarColor: '#C1C7CF transparent',
      },
      '*::-webkit-scrollbar': {
        width: '6px',
        height: '6px',
      },
      '*::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '*::-webkit-scrollbar-thumb': {
        background: '#C1C7CF',
        borderRadius: '100px',
      },
      '*::-webkit-scrollbar-thumb:hover': {
        background: '#A4ABB8',
      },
      '*::-webkit-scrollbar-button': {
        display: 'none',
      },
      '*::-webkit-scrollbar-corner': {
        background: 'transparent',
      },
    },
  },
  components: {
    Button: ButtonProps,
    Input: InputProps,
    Card: CardProps,
    Checkbox: CheckboxProps,
    Radio: RadioProps,
    Select,
    Tag,
    Textarea,
    Popover: PopoverProps,
  },
})

export default theme
